import { AirLock, Equipment, Extractor } from "./equipment.model";

// site models
export interface SiteModel {
  title: string;
  elementaryZones: ElementaryZone[];
  totalVolume: number;
}

export interface ElementaryZone {
  name: string;
  volume: number | null;
  personnelDecontamination: boolean;
  wasteDecontamination: boolean;
  extractorsInstallation: boolean;
  personnelEquipment?: AirLock;
  wasteEquipment?: AirLock;
  minimalDepressionValues: DepressionCalculatedValues;
  depressionToMaintainValues: DepressionCalculatedValues;
  isMandatory?: boolean; //Used only in equipment vue
  customEquipment?: Equipment | Extractor; //Used to temporary store an equipment in equipmentVue
  optional?: boolean; /* Evolution Majeure pour EACM*/
}


export class DepressionCalculatedValues {
  personnelSasDebit = 0;
  wastesSasDebit = 0;
  eacmDebit = 0;
  earDebit = 0;
  totalSasDebit = 0;
  eacmNumber = 0;
  totalAirDebitEacm = 0;
  earNumber = 0;
  earCapacity = 0;
  minimalAirZoneDebit = 0;
  totalAirIntakesDebit = 0;
  renewalRate = 0;
}
